module.exports = __webpack_public_path__ + "static/media/background-pattern.e5a54ed3.svg";